<template>
  <div class="mcard" style="width: 100%;">
    <loading-container :loading="loading">
      <!--<div class="row">
        <div class="col-8">
          <div class="notice" v-if="notice_title && notice_text">
            <div class="notice__title">
              <img src="../assets/icons/warning.svg" alt="">
              {{notice_title}}
            </div>
            <div class="notice__text">
              {{ notice_text }}
            </div>
          </div>
        </div>
        <div class="col-4">
          <div class="plug"></div>
        </div>
      </div>-->
      <div class="row mt-3">
        <div class="col-12">

        </div>
      </div>
      <div class="row mt-3">
        <div class="col-6">
          <div class="bordered-card" style="margin-bottom: 15px;">
            <div class="bordered-card__head">
              Сегодня на платформе
            </div>
            <div class="bordered-card__body">
              <div class="bordered-card__body-item" v-for="(item,idx) in daily" :key="idx">
                <div class="value" style="    font-size: 21px;">{{item.value}}</div>
                <div class="title">{{item.title}} {{ item.title == 'Сумма сделок' ? '(руб.)' : ''}}</div>
              </div>
            </div>
          </div>
          <div class="bordered-card">
            <div class="bordered-card__head">Топ товаров</div>
            <div class="bordered-card__items">
              <table class="items-table">
                <tr>
                  <th width="40px"></th>
                  <th>Название</th>
                  <th>Поставщик</th>
                  <th width="110px">Сумма продаж (руб.)</th>
                </tr>
                <tr v-for="(item, idx) in table" :key="idx">
                  <td><img v-if="item.image" :src="item.image" alt=""></td>
                  <router-link :to="'product/' + item.id" tag="td">
                    {{item.name}}
                  </router-link>
                  <td>{{item.supplier}}</td>
                  <td style="color: #2cb181; min-width: 92px; text-align: center;">{{item.sum}}</td>
                </tr>
              </table>
            </div>
          </div>
        </div>
        <div class="col-6">
          <div class="mb-3" style="max-height: 300px;overflow: hidden;" v-if="banner">
            <a :href="bannerUrl">
              <img style="width: 100%;height: 100%;object-fit: cover;" :src="banner">
            </a>

          </div>
          <div class="bordered-card">
            <div class="bordered-card__head">Новости</div>
            <div class="bordered-card__news">
              <div class="bordered-card__news-item" @click="$refs.new.open(item)" v-for="(item,idx) in news" :key="idx">
                <div class="title">{{item.title}}</div>
                <div class="info mt-1"><div class="author admin">{{item.author +','}}</div> {{item.time}}</div>
                <div class="text mt-1">{{item.preview}}</div>
              </div>
            </div>
          </div>
<!--          <div class="videoWrapper">
            <iframe width="100%" height="auto" src="https://www.youtube.com/embed/TGh9ChuGi0o" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
          </div>-->
        </div>
      </div>
    </loading-container>
    <news-modal ref="new" :news="news"/>
  </div>
</template>

<script>
import LoadingContainer from "@/components/loading-container";
import NewsModal from "@/components/modals/news-modal";

export default {
  name: "home",
  components: {
    LoadingContainer,
    NewsModal,
  },
  data: ()=>({
    loading: true,
    notice_title: '',
    notice_text: '',
    daily:[],
    news:[],
    table:[],
    banner: '',
    bannerUrl: ''
  }),
  mounted() {
    this.$http.post('/get-banner', {
      type:3,
    }).then(({data})=> {
      this.banner = data[0].path
      this.bannerUrl = data[0].url
      console.log(this.banner)
    });

    this.getStats();
  },
  methods: {
    getStats() {
      this.$http.post( '/get-stats',{ token: localStorage.getItem('token') })
          .then(({data}) => {
            this.daily = data?.daily;
            this.table = data?.products;
            this.notice_title = data.notification?.title;
            this.notice_text = data.notification?.description;
            this.news = data?.news;
          }).catch(() => {
            this.$toast.error('Ошибка!');
          })
            .finally(()=> this.loading = false)
    }
  }
}
</script>

<style scoped lang="scss">

.videoWrapper {
  position: relative;
  padding-bottom: 56.25%; /* 16:9 */
  height: 0;
}
.videoWrapper iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.mcard{
  padding: 35px;
  .notice{
    background: #FFFFFF;
    border: 1px solid #F39220;
    box-sizing: border-box;
    box-shadow: 0px 0px 3px #E5E5EA;
    border-radius: 4px;
    padding: 20px;
    font-weight: 500;
    font-size: 16px;
    line-height: 19px;
    color: #2D3137;
    &__title{
      display: flex;
      align-items: center;
      margin-bottom: 10px;
      img{
        margin-right: 10px;
      }
    }
    &__text{
      font-weight: normal;
      font-size: 12px;
      line-height: 14px;
      color: #636974;
    }
  }
  .plug{
    content: '';
    background: #EEF0F3;
    border-radius: 4px;
    height: 100%;
  }
  .bordered-card{
    background: #FFFFFF;
    box-shadow: 0px 0px 3px #E5E5EA;
    border-radius: 4px;
    border: 1px solid #EEF0F3;
    font-family: Roboto;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 19px;
    color: #2D3137;

    &__head{
      padding: 15px;
      border-bottom: 1px solid #EEF0F3;
    }
    &__items{
      background: #FFFFFF;
      overflow-y: scroll;
      table{
        tr{
          th{
            font-style: normal;
            font-weight: normal;
            font-size: 14px;
            line-height: 14px;
            color: #2D3137;
          }
          td{
            font-style: normal;
            font-weight: normal;
            font-size: 14px;
            line-height: 14px;
            color: #636974;
            cursor: pointer;
            img{
              height: 32px;
              width: 32px;
            }
          }
        }
      }
    }
    &__news{
      padding: 15px;
      height: 250px;
      overflow-y: scroll;
      background: #FFFFFF;
      &-item{
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 16px;
        color: #2D3137;
        padding: 15px;
        background: #F9F9FB;
        border: 1px solid transparent;
        box-sizing: border-box;
        border-radius: 4px;
        margin-bottom: 5px;
        &:hover{
          cursor: pointer;
          border: 1px solid #2CB181;
        }
        .info{
          display: flex;
          align-items: center;
          justify-content: flex-start;
          font-size: 11px;
          line-height: 13px;
          color: #636974;
          .author{
            margin-right: 5px;

            &.admin{
              color: #2CB181;
            }
          }
        }
        .text{
          font-weight: normal;
          font-size: 12px;
          line-height: 17px;
          color: #2D3137;
        }
      }
    }

    &__body{
      background: #FFFFFF;
      display: flex;
      align-items: center;
      justify-content: space-around;
      &-item{
        font-size: 36px;
        line-height: 42px;
        color: #2CB181;
        padding: 30px 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        border-right: 1px solid #EEF0F3;
        width: 35%;
        .title{
          font-weight: normal;
          font-size: 14px;
          line-height: 16px;
          color: #2D3137;
        }
      }
      &-item:nth-child(1),&-item:nth-child(2){
        width: 20%!important;
      }
      &-item:last-child {
        border-right: none;
      }
    }
  }
}
</style>
